import caseStudiesService from "@/modules/hollymontt-admin/services/caseStudiesService";
import clientsService from "@/modules/hollymontt-admin/services/clientsService";
import companiesService from "@/modules/hollymontt-admin/services/companiesService";
import couponsService from "@/modules/hollymontt-admin/services/couponsService";
import coursesService from "@/modules/hollymontt-admin/services/coursesService";
import courseClientsService from "@/modules/hollymontt-admin/services/courseClientsService";
import coursePhasesService from "@/modules/hollymontt-admin/services/coursePhasesService";
import dashboardServices from "@/modules/hollymontt-admin/services/dashboardService";
import dictionaryService from "@/modules/hollymontt-admin/services/dictionaryService";
import emailTemplatesService from "@/modules/hollymontt-admin/services/emailTemplatesService";
import invoicesService from "@/modules/hollymontt-admin/services/invoicesService";
import subscriptionsService from "@/modules/hollymontt-admin/services/subscriptionsService";
import subscriptionsEventsService from "@/modules/hollymontt-admin/services/subscriptionsEventsService";
import subscriptionTypesService from "@/modules/hollymontt-admin/services/subscriptionTypesService";
import portfoliosService from "@/modules/hollymontt-admin/services/portfoliosService";
import userService from "@/modules/hollymontt-admin/services/userService";
import videotutorialsService from "@/modules/hollymontt-admin/services/videotutorialsService";
import lessonsService from "@/modules/hollymontt-admin/services/lessonsService";
import trainingsService from "@/modules/hollymontt-admin/services/trainingsService";
import lazyPortfoliosService from "@/modules/hollymontt-admin/services/lazyPortfoliosService";
import courseReportsService from "@/modules/hollymontt-admin/services/courseReports";

export default [
  caseStudiesService,
  clientsService,
  companiesService,
  couponsService,
  coursesService,
  courseClientsService,
  coursePhasesService,
  courseReportsService,
  dashboardServices,
  dictionaryService,
  emailTemplatesService,
  invoicesService,
  lazyPortfoliosService,
  lessonsService,
  subscriptionsService,
  subscriptionsEventsService,
  subscriptionTypesService,
  userService,
  portfoliosService,
  trainingsService,
  videotutorialsService,
];
